import Precision from './Precision';

const resolvePrecisionActions = value => ({
    updatePrecision(nextPrecisionData) {
        Object.assign(value, new Precision(), nextPrecisionData);
    },
    disableFeature() {
        value.isEnabled = false;
    },
});

export default resolvePrecisionActions;
